var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-main',[_c('LocalNav'),_c('v-container',{staticClass:"pt-13 pt-sm-10 pt-lg-16"},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }